import type { SbRichTextProps } from '@storyblok/richtext';
import { attrsToHtmlString, processAttrs } from '@storyblok/richtext';

// Creates a link renderer that prepends internal (story) links with a base URL.
// Href resolution (anchor suffix, mailto: prefix) is delegated to processAttrs,
// which also strips Storyblok-internal attributes (linktype, uuid, anchor).
export function createPrependInternalLinkRenderer(prependLink: string) {
	return ({ attrs, children }: SbRichTextProps<'link'>): string => {
		const htmlAttrs = processAttrs('link', attrs ?? {});

		if (
			attrs?.linktype === 'story' &&
			typeof htmlAttrs['href'] === 'string'
		) {
			htmlAttrs['href'] = prependLink + htmlAttrs['href'];
		}

		return `<a${attrsToHtmlString(htmlAttrs)}>${children}</a>`;
	};
}
